import React from "react"
import _find from "lodash/find"
import PropTypes from "prop-types"

import ModernModal from "shared/components/ModernModal"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput"
import ModernFloatLabelSelect from "shared/components/ModernFloatLabelSelect"
import Typograph from "../../../../../../components/Typograph"

import styles from "./styles.css"

import { fileType, typeOptions } from "../../constants"

const AudioRequestModal = ({
  protocol,
  isOpen,
  onNextStep,
  onCloseModal,
  shippingMethod,
  onChangeShippingMethod,
  setEmail,
  email
}) => {
  function handleChangeType(e) {
    const currentValue = _find(fileType, (item) => item.type === e.value)

    onChangeShippingMethod({ type: e, format: currentValue })
  }

  const handleOnConfirm = () => {
    const protocolDetails = {
      ...protocol,
      type: shippingMethod.type.value,
      format: shippingMethod.format.value,
      email
    }

    onNextStep(protocolDetails)
  }

  return (
    <ModernModal
      isOpen={isOpen}
      cancelButtonText="Cancelar"
      confirmButtonText="Solicitar"
      onConfirm={handleOnConfirm}
      onClose={onCloseModal}
      onCancel={onCloseModal}
    >
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        Solicitar áudio
      </Typograph>

      <div className={styles.formContainer}>
        <ModernFloatLabelInput
          name="protocol"
          label="Número do protocolo"
          value={protocol.protocolNumber}
          disabled={true}
          containerClasses={styles.widthInput}
          margin="top_0"
        />
        <ModernFloatLabelInput
          name="date"
          label="Data"
          value={protocol.createdDate}
          disabled={true}
          containerClasses={styles.widthInput}
          margin="top_0"
        />
        <ModernFloatLabelSelect
          name="format"
          label="Forma de disponibilização"
          value={shippingMethod.type}
          onChange={handleChangeType}
          options={typeOptions}
          customStyles={customStylesSelect}
          margin="top_0"
        />
        <ModernFloatLabelInput
          name="type"
          label="Forma de envio"
          value={shippingMethod.format.value}
          disabled={true}
          containerClasses={styles.widthInput}
          margin="top_0"
        />
        <ModernFloatLabelInput
          name="email"
          label="E-mail para envio"
          margin="top_0"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
    </ModernModal>
  )
}

const customStylesSelect = {
  control: (provided) => ({
    ...provided,
    width: "238px !important"
  }),
  menu: (provided) => ({
    ...provided,
    width: "238px !important",
    position: "fixed !important",
    top: "auto !important"
  })
}

AudioRequestModal.propTypes = {
  isOpen: PropTypes.bool,
  protocol: PropTypes.object,
  onNextStep: PropTypes.func,
  onCloseModal: PropTypes.func,
  shippingMethod: PropTypes.object,
  onChangeShippingMethod: PropTypes.func,
  email: PropTypes.string,
  setEmail: PropTypes.func
}

export default AudioRequestModal



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/AudioRequest/components/AudioRequestModal/index.js